import { z } from 'zod';

/** Every error the API returns has one of these codes (design §6.12). */
export const ErrorCode = z.enum([
  'bad_request',
  'invalid_input',
  'unauthorized',
  'recent_login_required',
  'forbidden',
  'not_found',
  'conflict',
  'rate_limited',
  'unavailable',
  'internal',
  /** No connected Discord worker can do it (design §6.6). */
  'discord_unavailable',
  /** A worker took it but didn't finish in time. */
  'discord_timeout',
  /** The worker tried and Discord refused, or the outcome is unknown. */
  'discord_failed',
  /** The Discord user has no ITC Web access: no record, not active, or no gate role. */
  'not_linked',
]);
export type ErrorCode = z.infer<typeof ErrorCode>;

export const ERROR_STATUS: Readonly<Record<ErrorCode, number>> = {
  bad_request: 400,
  invalid_input: 400,
  unauthorized: 401,
  recent_login_required: 401,
  forbidden: 403,
  not_found: 404,
  conflict: 409,
  rate_limited: 429,
  unavailable: 503,
  internal: 500,
  discord_unavailable: 503,
  discord_timeout: 504,
  discord_failed: 502,
  not_linked: 401,
};

/** The one error shape: `{ error: { code, message, details? } }`. */
export const ErrorBody = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ErrorBody = z.infer<typeof ErrorBody>;
